import React, { useState, useEffect } from 'react';
import AppSidebar from '../../../components/AppSidebar';
import AppHeader from '../../../components/AppHeader';
import PageHeader from '../../../components/PageHeader';
import { proposalStatusOptions } from '../../../../src/utils/OptionUtils';
import { currencyOptions } from '../../../../src/utils/OptionUtils';
import { discountTypeOptions } from '../../../../src/utils/OptionUtils';
import DocumentForm from '../../../components/DocumentForm';
import CustomerService from '../../../services/CustomersService';
import LeadService from '../../../services/LeadsService';
import UsersService from '../../../services/UsersService';
import { useForm, Controller } from 'react-hook-form';
import SelectTag from "../../../components/SelectTag";
import {Countries} from "../../../utils/Countries"
import { toast, ToastContainer } from 'react-toastify';

const CreateProposal = () => {
  const { register, handleSubmit, setValue, control, getValues, watch, formState: { errors } } = useForm();
  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const startDate = watch('date')
  const handleChange = async (value) => {
    if (!value) {
      setSelectedValue(null);
    } else {
      const service = value === 'Lead' ? LeadService : CustomerService;
      if (service) {
        const response = await service.listAll();
        if (response.status === 200) {
          const result = response.data?.data?.map((item) => ({
            label: value === "Lead" ? item.name + " - " + item.email : item.company,
            value: item.id,
          }));

          setOptions(result || []);
        }
      }
      setSelectedValue(value);
    }
  };
  const fetchUsers = async () => {
    try {
      const response = await UsersService.list();
      if (response.status === 200) {
        setUserOptions(response?.data?.data?.map((item) => ({
          label: item.name + " - " + item.email,
          value: item.id,
        })));
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred");
      console.log("Error in getting users.", [error]);
    }
  }
  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRelatedChange = async (id, type) => {
    if (!id) {
      return false;
    } else {
      const service = type === 'Lead' ? LeadService : CustomerService;
      if (service) {
        const response = await service.get(id);
        if (response.status === 200) {
          const result = response.data?.data;
          setValue("related", result.id);
          setValue("related_name", type === "Lead" ? `${result.name} - ${result.email}` : result.company);
          setValue("to", type === "Lead" ? result.name : result.company);
          setValue("address", result.address);
          setValue("city", result.city);
          setValue("state", result.state);
          setValue("zipcode", result.zipcode || result.zipCode);
          setValue("country", result.country);
          setValue("email", type === "Lead" ? result.email : result.official_email);
          setValue("phone", result.phone);
          setValue("currency", result.currency ? "inr" : "INR");
        }
      }
    }
  };

  const onProposalSubmit = async (data) => {
    console.log(data);
  };

  return (
    <>
    <ToastContainer />
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <PageHeader title="Create Proposal" className="btn btn-sm btn-primary" link_to="/proposals" button_label="Back" />

          <div className="card mt-4 shadow-sm">
            <div className="card-body">
              <form onSubmit={handleSubmit(onProposalSubmit)}>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-12 col-xl-6">
                    <div className="mb-3">
                      <label htmlFor="subject" className="form-label">Subject</label>
                      <input type="text" className="form-control" name="subject" id="subject" {...register("subject", { required: true })} />
                      {errors.subject && <span className="text-danger">Subject is required</span>}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="related" className="form-label">Related</label>
                      <select className="form-control form-select" name="related" id="related" onChange={(e) => handleChange(e.target.value)}>
                        <option value="">Select Related</option>
                        <option value="Lead">Lead</option>
                        <option value="Customer">Customer</option>
                      </select>
                    </div>
                    {selectedValue === 'Lead' && (
                      <div className="mb-3">
                        <label htmlFor="lead" className="form-label">Lead</label>
                        <Controller
                          name="lead_id"
                          control={control}
                          render={({ field }) => (
                            <select
                              {...field}
                              className="form-select"
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                                handleRelatedChange(e.target.value, "Lead");
                              }}
                            >
                              <option value="" disabled>Select a lead</option>
                              {options.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        {errors.lead_id && <span className="text-danger">Lead is required</span>}
                      </div>
                    )}
                    {selectedValue === 'Customer' && (
                      <div className="mb-3">
                        <label htmlFor="customer" className="form-label">Customer</label>
                        <Controller
                          name="customer_id"
                          control={control}
                          render={({ field }) => (
                            <select
                              {...field}
                              className="form-select"
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.target.value);
                                handleRelatedChange(e.target.value, "Customer");
                              }}
                            >
                              <option value="" disabled>Select a customer</option>
                              {options.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        {errors.customer_id && <span className="text-danger">Customer is required</span>}
                      </div>
                    )}

                    <div className="row">
                    <div className="col-6">
                        <div className="form-group mb-3">
                          <label className="mb-1 form-label">Start Date</label>
                          <input
                            type="date"
                            {...register('date', {
                              required: "date is required",
                              validate: (value) => {
                                const openTill = getValues('open_till');
                                if (new Date(value) > new Date(openTill)) {
                                  return 'date cannot be later than open till';
                                }
                              }
                            })}
                            className={`form-control ${errors?.date ? 'is-invalid' : ''}`}
                            min={today || startDate}
                          />
                          {errors.date && <div className="invalid-feedback">{errors?.date?.message}</div>}
                        </div>
                      </div>
                      <div className="col-6">
                      <div className="form-group mb-3">
                        <label className="mb-1 form-label">Open Till</label>
                        <input
                          type="date"
                          {...register('open_till', { required: "Open till is required" })}
                          className={`form-control ${errors.open_till ? 'is-invalid' : ''}`}
                          min={startDate}
                        />
                        {errors?.open_till && <div className="invalid-feedback">{errors?.open_till?.message}</div>}
                      </div>
                    </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="currency" className="form-label">Currency</label>
                          <div className="input-group">
                            <div className="flex-grow-1">
                              <SelectTag
                                options={currencyOptions}
                                name={"currency"}
                                label={"Currency"}
                                control={control}
                              />
                            </div>
                            {errors.currency && <span className="text-danger">Currency is required</span>}
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="discount_type" className="form-label">Discount Type</label>
                          <SelectTag
                            options={discountTypeOptions}
                            name={"discount_type"}
                            label={"Discount Type"}
                            control={control}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-12 col-xl-6">
                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="status" className="form-label">Status</label>
                          <SelectTag
                            options={proposalStatusOptions}
                            name={"status"}
                            label={"Status"}
                            control={control}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="assign" className="form-label">Assign</label>
                          <SelectTag
                            options={userOptions}
                            name={"assign"}
                            label={"Assignee"}
                            control={control}
                          />
                          {errors.assign && <span className="text-danger">Assign is required</span>}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="to" className="form-label">To</label>
                      <input type="text" className="form-control" name="to" id="to" {...register("to", { required: true })} />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="address" className="form-label">Address</label>
                      <textarea className="form-control" name="address" id="address" rows="3" {...register("address", { required: true })}></textarea>
                      {errors.address && <span className="text-danger">Address is required</span>}
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="city" className="form-label">City</label>
                          <input type="text" className="form-control" name="city" id="city" {...register("city", { required: true })} />
                          {errors.city && <span className="text-danger">City is required</span>}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state" className="form-label">State</label>
                          <input type="text" className="form-control" name="state" id="state" {...register("state", { required: true })} />
                          {errors.state && <span className="text-danger">State is required</span>}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country" className="form-label">Country</label>
                          <SelectTag
                            options={Countries}
                            name={"country"}
                            label={"Country"}
                            control={control}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="zipcode" className="form-label">Zipcode</label>
                          <input type="text" className="form-control" name="zipcode" id="zipcode" maxLength={6} {...register("zipcode", { required: true })} />
                          {errors.zipcode && <span className="text-danger">Zipcode is required</span>}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">Email</label>
                          <input type="email" className="form-control" name="email" id="email"
                            {...register("email", {
                              required: true,
                              pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: 'Invalid email format'
                            })}
                          />
                          {errors.email && <span className="text-danger">Email is required</span>}
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="phone" className="form-label">Phone</label>
                          <input type="text" className="form-control" name="phone" id="phone" maxLength={10} {...register("phone", { required: true })} />
                          {errors.phone && <span className="text-danger">Phone is required</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="row">
                  <DocumentForm />
                </div>
                <div className="text-end mt-3">
                  <button type="submit" className="btn btn-light me-2">Save & Send</button>
                  <button type="submit" className="btn btn-primary">Save</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateProposal;
